const colors = [
  '#0000ff',
  '#8a2be2',
  '#a52a2a',
  '#5f9ea0',
  '#d2691e',
  '#ff7f50',
  '#6495ed',
  '#dc143c',
  '#00008b',
  '#008b8b',
  '#b8860b',
  '#006400',
  '#8b008b',
  '#556b2f',
  '#ff8c00',
  '#9932cc',
  '#8b0000',
  '#483d8b',
  '#2f4f4f',
  '#9400d3',
  '#1e90ff',
  '#b22222',
  '#228b22',
  '#daa520',
  '#008000',
  '#ff69b4',
  '#4b0082',
  '#800000',
  '#66cdaa',
  '#0000cd',
  '#ba55d3',
  '#9370d8',
  '#3cb371',
  '#7b68ee',
  '#c71585',
  '#000080',
  '#808000',
  '#6b8e23',
  '#ffa500',
  '#ff4500',
  '#da70d6',
  '#cd853f',
  '#800080',
  '#4169e1',
  '#8b4513',
  '#fa8072',
  '#2e8b57',
  '#a0522d',
  '#6a5acd',
  '#4682b4',
  '#008080',
  '#ff6347',
];

export const getColorForId = (id) => {
  if (!id) {
    return colors[Math.floor(Math.random() * colors.length)];
  }
  const number = String(id).split('')
    .map(c => c.charCodeAt(0))
    .join('');
  return colors[number % colors.length];
};
